<section class="main-content wrapper content-padding " style="margin-top: 50px;">
    <div class="content-panel">
        <div class="tabs">
            <label class="tab">
                <a class="tab-link active-tab">Prodotto in bundle</a>
            </label>
        </div>

        <div class="item nowrap">
            <span class="btn-container top-button-container">
                <button class="btn btn-white vertical align-items-center" routerLink="nuovo">
                    Aggiungi<i class="ml-10 fas fa-plus"></i>
                </button>
            </span>
        </div>

        <hr class="gold-hr">

        <section class="main-content wrapper scroll-delivery">
            <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

            <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
                <form class="table-row-container row first-row filter" [formGroup]="filterForm" (ngSubmit)="filter()" *ngIf="filterForm">
                    <div class="item data-col-">
                        <h4 class="title" (click)="navigateOrder('BundleProduct.id')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('BundleProduct.id')"></i>
                            ID
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="BundleProduct.id" min="1000" max="10000" >
                        </span>
                    </div>

                    <div class="item data-col-" >
                        <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                            PARTNER
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="Partner.businessName" >
                        </span>
                    </div>

                    <div class="item data-col-">
                        <h4 class="title">
                            PROVINCIA
                        </h4>

                        <span class="data">
                            <input type="text" formControlName="province" placeholder="MI">
                        </span>
                    </div>

                    <div class="item nowrap">
                        <h4 class="title hide-on-mobile">AZIONI</h4>
                        <span class="data-row-left btn-container">
                            <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                                <i class="fas fa-search"></i>
                            </button>
                            <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter();">
                                <i class="fas fa-undo"></i>
                            </button>
                        </span>
                    </div>
                </form>

                <div class="table-row-container row" *ngFor="let bundleProduct of bundleProducts">
                    <div class="item data-col-10">
                        <h4 class="title">
                            ID :
                        </h4>
                        <div class="data data-id">
                            <div>
                                <a [routerLink]="getLink(bundleProduct)" class="redirect-sale">
                                    #{{ bundleProduct.id || "---" }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="item data-col-10">
                        <h4 class="title">
                            <i class="sort-icon fas"></i>
                            Partner
                        </h4>
                        <div class="data">
                            <div>
                                <a [routerLink]="getLink(bundleProduct)">
                                    {{ bundleProduct.partner?.businessName }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="item data-col-10">
                        <h4 class="title">
                            <i class="sort-icon fas"></i>
                            PROVINCIA
                        </h4>

                        <div class="data">
                            <div>
                                <a [routerLink]="getLink(bundleProduct)">
                                    <span
                                        *ngFor="let province of bundleProduct.provinces"
                                        class="province-badge">
                                        {{ province }}
                                    </span>

                                    <span *ngIf="!bundleProduct.provinces?.length">
                                        N/A
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="item nowrap">
                        <span class="data-row-left btn-container btn-container-actions">
                            <button class="btn vertical align-items-center" [routerLink]="['/bundle/product/edit', bundleProduct.id]">
                                Modifica
                            </button>
                            <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(bundleProduct)">
                                Elimina<i class="ml-10 far fa-trash-alt"></i>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </section>
    </div>
</section>
